
import { Route } from "vue-router";
// components
import DenyGpsAlertView from "@/components/common/deny-gps-alert-view.vue";
import EvacuationAlert from "@/components/common/evacuation-alert-view.vue";
import SplitViewPC from "@/components/maps-view/split-view-pc.vue";
import GoogleMaps from "@/components/maps-view/google-maps-merged.vue";
import EntryRestrictedPopupAlert from "@/components/common/entryRestricted-popup-alert.vue";
import FullscreenAlertReload from "@/components/common/fullscreen-alert-reload.vue";
import FirstAccessSearch from "@/components/maps-view/first-access-search.vue";
import PollAlert from "@/components/common/poll-alert.vue";
import NotReadyAlert from "@/components/common/not-ready-alert.vue";

const GoogleMapsError = () => import("@/components/maps-view/google-maps-error.vue");
// mixins
import MapsViewMixin from "@/mixins/maps-view";
import VueTypedMixin from "vue-typed-mixins";

export default VueTypedMixin(MapsViewMixin).extend({
  name: "views-map-desktop",
  mixins: [MapsViewMixin],
  components: {
    GoogleMapsError,
    NotReadyAlert,
    DenyGpsAlertView,
    FirstAccessSearch,
    EvacuationAlert,
    GoogleMaps,
    SplitViewPC,
    EntryRestrictedPopupAlert,
    FullscreenAlertReload,
    PollAlert,
    AdsAlert: () => import("@/components/common/alert-modal/ads-alert.vue"),
  },
  computed: {
    showHinanjoLink(): boolean {
      return this.$store.state.data.selectedGenre === "disaster-prevention";
    },
    currentEnv(): string {
      return process.env.VUE_APP_MODE || "development";
    },
  },
  /** @remarks detect route changes of children */
  beforeRouteUpdate(to: Route, _: Route, next) {
    console.log(`maps beforeRouteUpdate to: ${to.fullPath}`);
    // watch route back to root
    if (/\/(en|tw|cn)*(\/)*$/.test(to.path)) {
      this.$store.commit("ui/setShowFacility", false);
      this.$store.commit("ui/setAnnouncementViewShown", false);
      this.$store.commit("ui/stopElementScrolling", false);
      this.$store.commit("ui/isDetailViewScrollTop", false);
      this.$store.commit("ui/isFetchingError", false);
      this.$store.commit("ui/resizeGMap", false); // reset map size to full screen
      this.resetMarkerIcons();
      this.resetLayerOfWhiteBgView(); // white bg for iOS 12-
      this.enlargeMarkerUI();
    }
    if (to.path.includes("/area") && to.params.areaName) {
      // to prevent vue-router gets previous parameters
      setTimeout(() => {
        this.searchByAccessAreaName(to.params.areaName);
      }, 100);
    }
    if (to.path.includes("/map") && to.params.latlng) {
      // move card back on switching child-routes
      this.moveToSelectedCard(this.selectedPlaceIdHash);
      this.searchByLatLngParam(to.params.latlng);
    }
    // hide search button at each page switching
    this.setIsSearchAgain(false);
    this.setIsFirstLoadMap(false);
    next();
  },
  methods: {
    /** @remarks update PC UI */
    handleMouseClickPin(placeIdHash: string) {
      this.$gtag.event("click", {
        event_category: "Map pin",
        event_label: placeIdHash,
        value: 1,
      });

      this.enlargeSpecifiedMarkerUI(placeIdHash);
    },
    enlargeSpecifiedMarkerUI(placeIdHash: string) {
      const marker = this.findSpecifiedMarkerByPlaceIdHash(placeIdHash) as google.maps.Marker | undefined;
      this.resetMarkerIcons();
      if (marker === undefined) return;
      this.enlargeSelectedMarker(marker);
    },
  },
});
